import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { TableDataResponse } from 'types/general';
import { IBenefitTemplate } from 'types/income';
import { BenefitTemplatesFilters } from './benefit-templates.types';

interface GetBenefitTemplates {
  filters: Partial<BenefitTemplatesFilters>;
}

export const loaders = {
  getBenefitTemplates: ({ filters }: GetBenefitTemplates) => {
    return api<TableDataResponse<IBenefitTemplate>>({
      url: Endpoints.benefitTemplates.root,
      params: {
        filter: {
          type: filters.category,
          supportedCountries: filters.countries,
          supportedLanguages: filters.languages,
        },
      },
    });
  },
};
